module.exports = __webpack_public_path__ + "static/img/produto_g.bcac1cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/tubaina/produto_g.png
// module id = w3sr
// module chunks = 0